import ActionsList, {
  releaseCardAnomalyLockCheck,
} from 'front-office/components/release-id-card/actions-list';
import { ReleaseIdCardSearchPersonCrumbs } from 'front-office/constants/release-id-card-crumbs';
import { Fragment, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { Anomaly } from 'front-office/view-models/common-certificate-form';
import AnomalieErrorModal from 'shell/components/shared/anomalie-modal';
import ReleaseIdCardSearch from 'shell/components/shared/person-search/release-id-card-search';

export interface PermitErrorModal {
  open: boolean;
  message?: string;
  errorExists?: boolean;
}
const ReleaseIdCardSearchPersonPage = (): React.ReactElement => {
  const [errorModalOpen, setErrorModal] = useState<boolean>(false);
  const [isNoteAnomalieModalClosed, setNoteAnomalieModal] = useState<boolean>(false);
  const [anomalieList, setAnomalieList] = useState<Array<Anomaly> | null>(null);

  return (
    <Fragment>
      <Breadcrumbs items={ReleaseIdCardSearchPersonCrumbs} />
      <ReleaseIdCardSearch
        setAnomalieList={(anomaly) => setAnomalieList(anomaly)}
        setErrorModal={setErrorModal}
        checkForError={(response) => {
          return releaseCardAnomalyLockCheck(response.releaseIdCard.anomalie);
        }}
        isNoteAnomalieModalClosed={isNoteAnomalieModalClosed}
        pathname="/sportello/rilascio-carta/rilascio"
        action={ActionsList}
        url="/persona/ricerca-rilascio-cie"
        addedTitle="- Rilascio Carta Identità"
      />
      {anomalieList !== null && anomalieList?.length > 0 ? (
        <AnomalieErrorModal
          open={errorModalOpen}
          onClose={() => {
            setErrorModal(false);
            setNoteAnomalieModal(true);
          }}
          dataPersons={anomalieList as Array<Anomaly>}
        />
      ) : (
        <></>
      )}
    </Fragment>
  );
};

ReleaseIdCardSearchPersonPage.displayName = 'Release id card search person page component';

export default ReleaseIdCardSearchPersonPage;
